<template>
  <div class="live-banner">
    <div class="live-banner-content">
      <h3>🔥 Battle Resto EN DIRECT !</h3>
      <p>Collège Victor Hugo vs Collège Jean Moulin - Qui gaspillera le moins cette semaine ?</p>
    </div>
    <div class="live-timer">
      <div class="time">2j 14h</div>
      <div class="label">Temps restant</div>
    </div>
    <button class="cta-button">Voir le Classement</button>
  </div>
</template>
<script>
export default {
  name: "LiveChallengeBanner",
}
</script>
<style scoped>
.live-banner {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 12px;
  padding: 25px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}
.live-banner-content h3 {
  font-size: 20px;
  margin-bottom: 8px;
}
.live-banner-content p {
  opacity: 0.9;
  font-size: 14px;
}
.live-timer {
  background: rgba(255, 255, 255, 0.2);
  padding: 15px 25px;
  border-radius: 10px;
  text-align: center;
}
.live-timer .time {
  font-size: 28px;
  font-weight: bold;
}
.live-timer .label {
  font-size: 12px;
  opacity: 0.9;
}
.cta-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);
}
</style>
